'use client'

import type { ProfileCardRecord } from '@/features/profiles/types/profile-search'
import { cn } from '@/shared/lib/utils'
import { CosmeticAvatarComposite } from '@/shared/ui/CosmeticAvatarComposite'

interface ProfileSearchCardProps {
  record: ProfileCardRecord
  onClick: () => void
}

export function ProfileSearchCard({ record, onClick }: ProfileSearchCardProps) {
  const showPoints = record.points !== undefined && record.points !== null

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      }}
      className={cn(
        'flex items-center px-3 gap-2 py-3 cursor-pointer',
        'hover:bg-black/5 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset'
      )}
      aria-label={`Ver perfil de ${record.name}`}
    >
      <div className="flex items-center gap-2 grow min-w-0">
        <CosmeticAvatarComposite
          avatar={record.avatar}
          frame={record.frame}
          background={record.background}
          size="xs"
          className="shrink-0"
        />
        <div className="flex flex-col min-w-0 grow">
          <span className="text-md lg:text-lg font-semibold text-black line-clamp-1">
            {record.name}
          </span>
          {record.school?.name && (
            <span className="text-xs text-gray-400 line-clamp-1">
              {record.school.name}
            </span>
          )}
        </div>
        {showPoints && (
          <span className="shrink-0 font-bold text-[#0063E5] text-md lg:text-lg font-sans">
            {record.points}
          </span>
        )}
      </div>
    </div>
  )
}
